@import (reference) "../../references.less";

.root {
  display: block;
  top: 0;
  position: absolute;
  .size(100%);
}

/**
 HEADER
 */
.header {
  position: relative;
}

.logo {
  .absoluteCenter(x);
  .R(margin-top, 100);
}

.githubLink {
  position: absolute;
  .R(top, @ui-border-margin-value);
  .R(right, @ui-border-margin-value);
}

.github {
  transform: scale(1);
  transition: transform 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);

  path {
    transition: fill 200ms cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  &:hover {
    transform: scale(1.2);
    path {
      fill: @color-red;
    }
  }
}

/**
CONTENT
 */
.content {
  //  overflow: hidden;
  .absoluteCenter();
  //  .R(height, auto);
  width: 100%;
  .R(margin-top, 50);
}

.line {
  background-color: @color-blue-2;
  width: 100vw;
  .R(height,75,  100);
  .absoluteCenter();
  .R(margin-top, 0);
}

.polaroids {
  width: 100%;
  overflow: hidden;
  .R(height, 450);

  display: block;
  transform-origin: center center;
}

.polaroidsInner {
  .size(100%);
  transform: scale(0.66);
  @media (min-width: @breakpoint-tablet) {
    transform: none;
  }
}
.polaroid {
  position: absolute;
  top: 50%;
  left: 50%;
  transform+_: translate(-50%, -50%);

  &_left {
    .R(margin-left, -110);
    transform: translate(-50%, -50%) scale(0.85) rotate(-17deg);
  }
  &_center {
    transform: translate(-50%, -50%) scale(0.6) rotate(2deg);
    .R(margin-top, -110);
    .R(margin-left, 60);
  }
  &_right {
    .R(margin-left, 110);
    transform: translate(-50%, -50%) scale(0.67) rotate(13deg);
  }
}

.input {
  .absoluteCenter(x);
  position: fixed;
  top: auto;
  .R(bottom, 70, 75);
}

.gallery {
}

/**
 FOOTER
 */
.footer {
  width: 100%;
  text-align: center;
  position: absolute;
  .R(bottom, @ui-border-margin-value, 0);
}

.donateLink {
  visibility: hidden; // TWEEN
  display: block;
  .text-link();
  @media (min-width: @breakpoint-tablet) {
    position: absolute;
    .R(left, @ui-border-margin-value);
    .R(bottom, @ui-border-margin-value);
  }

  span {
    text-decoration: underline;
  }
}

.creditLink {
  visibility: hidden; // TWEEN
  display: block;
  .R(margin-top, 10, 0);
  .text-link();
  @media (min-width: @breakpoint-tablet) {
    position: absolute;
    .R(right, @ui-border-margin-value);
    .R(bottom, @ui-border-margin-value);
  }
}
